import React, {useContext} from "react";
import { Link } from "react-router-dom";

import { ThemeContext } from "../../Context/ThemeWrapper";

import styles from "./Logo.module.scss";

const Logo = () => {
    const themeContext = useContext(ThemeContext);
    
    return (
        <Link
            to="/home"
            key="home"
            className={styles.brand}
        >
            {themeContext.theme === "light" && <img alt="Brand" src="./images/rainbow_dev_hub.png" />}
            {themeContext.theme === "dark" && <img alt="Brand" src="./images/rainbow_dev_hub_dark.png" />}
        </Link>
    );
}

export default Logo;